const SendMessageIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5217"
            data-name="Rectangle 5217"
            width="18"
            height="18"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g id="Mask_Group_638" data-name="Mask Group 638">
        <g id="send-mail_1_" data-name="send-mail (1)" transform="translate(0.457 0.49)">
          <path
            id="Path_78486"
            data-name="Path 78486"
            d="M132.885,14.862v5.292a.5.5,0,0,1-.906.3l-2.585-3.446-.788-.4L120.075,4.542l-.159-.938,1.386.766,11.586,10.058Z"
            transform="translate(-119.737 -3.483)"
            fill="#d5d5d5"
          />
          <path
            id="Path_78487"
            data-name="Path 78487"
            d="M.517.04c.023.009,16.178,8.12,16.2,8.131a.5.5,0,0,1,.039.879l-3.786,2.33L0,.122H0A.487.487,0,0,1,.517.04Z"
            transform="translate(0.18 0)"
            fill="#fff"
          />
          <path
            id="Path_78488"
            data-name="Path 78488"
            d="M224.224,3.629c.007-.007.01-.018.017-.025l.1.14,9.38,13.266-5.805,3.573a.5.5,0,0,1-.758-.336L224.07,4.079A.5.5,0,0,1,224.224,3.629Z"
            transform="translate(-224.062 -3.483)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
export default SendMessageIcon;
